import * as React from "react"
import { AppTableSeeker } from "@components"
import { mergeDicts } from "@ui-seeker/utils"

import { actionsColumn, associatedSkuColumn, validatedColumn, priceColumn, productRawColumn, retailerInfoColumn, scoringColumn } from "./columns"


export default function AdminNewListedBaseTable({ id, data=[], title='', subtitle='', hideActions=false, isSkuMappingTable=false, ...props }) {
    return <AppTableSeeker
		title={title}
		subtitle={subtitle}
		data={data}
		columns={[
			...retailerInfoColumn(),
			...productRawColumn(),
			...associatedSkuColumn(isSkuMappingTable),
			scoringColumn(),
			priceColumn(),
			validatedColumn(isSkuMappingTable),
			...( hideActions ? [] : [actionsColumn(isSkuMappingTable)])
		]}
		{...props}
		options={{
			print: false,
			...props?.options,
			enhancedSetRowProps: () => mergeDicts({ sx: {
				"&:has(.is-open)": {backgroundColor: "warning.light"},
			}}, props?.options?.enhancedSetRowProps && props?.options?.enhancedSetRowProps())
		}}
	/>
}